import type { AuditLog } from '../types';

function triggerDownload(
  content: string,
  filename: string,
  mimeType: string
): void {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeCSV(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function exportLogsAsCsv(logs: AuditLog[]): void {
  const headers = [
    'ID',
    'Action',
    'User',
    'Subject Type',
    'Subject ID',
    'Timestamp'
  ];
  const rows = logs.map((log) => [
    String(log.id),
    log.action,
    log.user?.name ?? '',
    log.subject_type ?? '',
    log.subject_id != null ? String(log.subject_id) : '',
    log.created_at
  ]);

  const csv = [headers, ...rows]
    .map((row) => row.map(escapeCSV).join(','))
    .join('\n');

  const timestamp = new Date().toISOString().slice(0, 10);
  triggerDownload(
    csv,
    `system-logs-${timestamp}.csv`,
    'text/csv;charset=utf-8;'
  );
}

export function exportLogsAsJson(logs: AuditLog[]): void {
  const data = logs.map((log) => ({
    id: log.id,
    action: log.action,
    user: log.user?.name ?? null,
    subject_type: log.subject_type,
    subject_id: log.subject_id,
    meta: log.meta,
    created_at: log.created_at
  }));

  const json = JSON.stringify(data, null, 2);

  const timestamp = new Date().toISOString().slice(0, 10);
  triggerDownload(
    json,
    `system-logs-${timestamp}.json`,
    'application/json;charset=utf-8;'
  );
}
